/**
 * @NOTE by hartha
 * This is a bad design.
 * this file should be removed
 */
import { WEBSOCKET_MESSAGE, DEFAULT_PREFIX } from "@giantmachines/redux-websocket";

import { ExecutionStatuses } from "../../constants/execution-statuses";
import { UITextAndMessages } from "../../constants/UITextAndMessages";
import { Prefixs } from "../../socket/socketPrefix";
import * as actionTyps from "../actions/actions";

export const initialState = {
  message: "",
  error: "",
  errorTitle: "",
  info: "",
  description: "",
  pageNotFound: "",
  excuteType: "",
};

export const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTyps.SUCCESS_MESSAGE:
      return {
        ...state,
        message: action.message,
        description: action.description,
      };
    case actionTyps.ERORR_MESSAGE:
      return {
        ...state,
        error: action.error,
        errorTitle: action.errorTitle,
      };
    case actionTyps.INFO_MESSAGE:
      return {
        ...state,
        info: action.error,
      };
    case actionTyps.PAGE_NOT_FOUND:
      return {
        ...state,
        pageNotFound: "404",
      };
    case actionTyps.REINIT_ALERT_MESSAGE:
      return {
        ...state,
        message: "",
        error: "",
        info: "",
      };
    case actionTyps.RUN_EXECUTION_TYPE:
      return {
        ...state,
        excuteType: action.excuteType,
      };

    case `${DEFAULT_PREFIX}::${WEBSOCKET_MESSAGE}`:
    case `${Prefixs.PREDICTION_PREFIX}::${WEBSOCKET_MESSAGE}`:
    case `${Prefixs.TRAIN_PREFIX}::${WEBSOCKET_MESSAGE}`:
    case `${Prefixs.DEPLOY_PREFIX}::${WEBSOCKET_MESSAGE}`:
      const msg = JSON.parse(action.payload.message);

      if (msg.messageName === "app-exec::status" && msg.payload.status === ExecutionStatuses.SUCCEEDED) {
        // TOOD: use a state to set the type of execution and
        // show a sueccess message based on execution type
        // the current implementaion has error cases

        let msgText;
        if (window.location.pathname.indexOf("datasets/train") > -1) {
          if (state.excuteType === "train") msgText = "Training completed successfully";
          // if (state.excuteType === "deploy")
          //   msgText = "Deploying completed successfully";
        } else if (window.location.pathname.indexOf("datasets/predict") > -1)
          msgText = "Prediction completed successfully";
        // else msgText = "App executed successfully";
        // else if (window.location.pathname.indexOf("datasets/preview") > -1)
        //   msgText = "Analysis completed successfully";
        return {
          ...state,
          // temp
          message: msgText,
        };
      } else if (msg.messageName === "app-exec::status" && msg.payload.status === ExecutionStatuses.FAILED) {
        // TOOD: use a state to set the type of execution and
        // show a error message based on execution type
        // the current implementaion has error cases

        let msgText;
        if (window.location.pathname.indexOf("datasets/train") > -1) {
          if (state.excuteType === "train") msgText = "Training failed. Try again.";
          if (state.excuteType === "deploy") msgText = "Deploying failed. Try again.";
        } else if (window.location.pathname.indexOf("datasets/predict") > -1) msgText = "Prediction failed. Try again.";
        else if (window.location.pathname.indexOf("datasets/preview") > -1)
          msgText = UITextAndMessages.dataAnalisysFailedMessage();
        else if (window.location.pathname.indexOf("datasets/qc-deployment") > -1)
          state.excuteType === "deploy"
            ? (msgText = "Deploying failed. Try again.")
            : (msgText = "Prediction failed. Try again.");
        // else msgText = "App Execution Failed!";

        return {
          ...state,
          // temp
          error: msgText,
        };
      } else if (msg.messageName === "app-exec::status" && msg.payload.status === ExecutionStatuses.CANELED) {
        // TOOD: use a state to set the type of execution and
        // show a info message based on execution type
        // the current implementaion has error cases
        let msgText;
        if (window.location.pathname.indexOf("datasets/train") > -1) msgText = "Training cancelled successfully.";
        else if (window.location.pathname.indexOf("datasets/predict") > -1)
          msgText = "Prediction cancelled successfully.";
        else if (window.location.pathname.indexOf("datasets/preview") > -1)
          msgText = "Analysis cancelled successfully.";
        else if (window.location.pathname.indexOf("datasets/qc-deployment") > -1)
          state.excuteType === "deploy"
            ? (msgText = "Deployment cancelled successfully.")
            : (msgText = "Prediction cancelled successfully.");

        return {
          ...state,
          // temp
          info: msgText,
        };
      }
    default:
      return state;
  }
};
